import { motion } from "framer-motion";
import { Trophy } from "lucide-react";
import { Reveal } from "./Reveal";

const BANNER = "https://customer-assets-agu9un31.emergentagent.net/job_timbodaking-media/artifacts/e497lfyy_image.png";

export default function Awards({ items = [] }) {
  return (
    <section id="awards" className="relative bg-obsidian pb-24 md:pb-40" data-testid="awards-section">
      {/* Full-width banner */}
      <div className="relative h-[56vh] md:h-[72vh] min-h-[440px] w-full overflow-hidden">
        <motion.img
          src={BANNER}
          alt="Timbaland at the Songwriters Hall of Fame"
          initial={{ scale: 1.08 }}
          animate={{ scale: 1 }}
          transition={{ duration: 1.8, ease: [0.16, 1, 0.3, 1] }}
          className="absolute inset-0 w-full h-full object-cover object-top"
          data-testid="awards-banner"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-obsidian via-obsidian/30 to-obsidian/50" />
        <div className="absolute inset-0 flex flex-col justify-end">
          <div className="max-w-[1600px] mx-auto w-full px-6 md:px-12 pb-10 md:pb-14">
            <Reveal>
              <p className="overline text-gold mb-5">Honors & Recognition</p>
              <h1 className="headline text-6xl md:text-9xl text-white">Awards</h1>
            </Reveal>
          </div>
        </div>
        <span className="absolute bottom-3 right-4 text-[0.58rem] md:text-[0.62rem] text-white/45 font-body tracking-wide">
          Photo by Bennett Raglin/Getty Images for Songwriters Hall Of Fame
        </span>
      </div>

      <div className="max-w-[1600px] mx-auto px-6 md:px-12 pt-16 md:pt-24">
        <div className="border-t border-white/10">
          {items.map((a, i) => (
            <motion.div
              key={a.id}
              data-testid={`award-item-${i}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.6, delay: (i % 3) * 0.06, ease: [0.16, 1, 0.3, 1] }}
              className="group grid grid-cols-12 gap-4 items-baseline py-7 md:py-9 border-b border-white/10 hover:bg-white/[0.02] transition-colors px-2"
            >
              <span className="col-span-3 md:col-span-2 font-display font-700 text-2xl md:text-4xl text-white/25 group-hover:text-gold transition-colors">
                {a.year}
              </span>
              <div className="col-span-9 md:col-span-7">
                <h3 className="font-editorial italic text-2xl md:text-3xl text-white mb-1">{a.title}</h3>
                <p className="font-display uppercase tracking-[0.14em] text-[0.72rem] text-white/55">{a.category}</p>
                {a.work && <p className="font-body text-white/45 text-sm mt-1">{a.work}</p>}
              </div>
              <div className="col-span-12 md:col-span-3 md:text-right">
                <span
                  className={`inline-flex items-center gap-2 font-display uppercase tracking-[0.16em] text-[0.66rem] px-3 py-1.5 border ${
                    (a.result || "").toLowerCase() === "won" ? "border-gold text-gold" : "border-white/25 text-white/60"
                  }`}
                >
                  <Trophy size={12} /> {a.result}
                </span>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
